module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot2-376b84c0232f7fc7ab2626484c082584.png";